/**
 * Created by Ivan on 10.08.2026
 */

const StickersBookSeasonWindow2 = Prefab.createWindow("stickers2_book_season_window", "stickers2_book_season_window_prefab_json", {
    bundles: (season) => {
        const seasonBundle = SeasonCollectionsHelper2.getSeasonBundleName(cleverapps.stickersBook2.season);
        return !season.fallback && SeasonCollectionsHelper2.hasSeasonBundle(cleverapps.stickersBook2.season) ? [seasonBundle] : ["stickers2_book_season_window_fallback"];
    }
});
